if (!customElements.get('cc-video')) {
    customElements.define(
      'cc-video',
      class CCVideo extends HTMLElement {
        constructor() {
          super();
          this.href = null || this.getAttribute('data-href')
          this.video = this.querySelector('video');
          this.init();
        }
        init() {
          this.controls();
          if (this.video) {
            if(this.href) {
              this.video.addEventListener('click', this.redirect.bind(this))
            }
          }
        }
        redirect(e) {
          let filterLink = document.createElement('a')
          filterLink.setAttribute('href', this.href)
          filterLink.click();
        }
        controls() {
          this.videoPlayBtn = this.querySelector('.video__toggle__play');
          this.videoPauseBtn = this.querySelector('.video__toggle__pause');
          this.video = this.querySelector('video');

          // play/pause buttons
          this.videoPlayBtn.addEventListener('click', (e) => {
            this.videoPlayBtn.classList.add('hidden');
            this.videoPauseBtn.classList.remove('hidden');
            this.querySelector('video').play();
          });
          this.videoPauseBtn.addEventListener('click', (e) => {
            this.videoPauseBtn.classList.add('hidden');
            this.videoPlayBtn.classList.remove('hidden');
            this.querySelector('video').pause();
          });
          this.video.addEventListener('ended', () => {
            this.videoPauseBtn.classList.add('hidden');
            this.videoPlayBtn.classList.remove('hidden');
          });
        }
      }
    );
  }